<template>
  <div>
    <div class="widget_heading text-center">
      <span class="float-right text-danger">
        Los campos con (*) son obligatorios
      </span>
    </div>
    <div class="financing_calculatoe">
      <div class="form-group">
        <label class="form-label">
          Valor del vehículo
          <span class="text-danger">*</span>
        </label>
        <vue-autonumeric
          :class="['form-control', v_vehiculo_req ? 'feedback_input' : '' || v_vehiculo_val ? 'feedback_input' : '']"
          type="text"
          :options="optionsNumeric"
          v-model="v_vehiculo"
        >
        </vue-autonumeric>
        <div class="feedback">
          <span v-if="v_vehiculo_req">Este campo es requerido</span>
          <span v-if="v_vehiculo_val">El valor debe ser mínimo $35.000.000</span>
        </div>
      </div>
      <div class="form-group">
        <label class="form-label">
          Cuota inicial
        </label>
        <vue-autonumeric
          class="form-control"
          type="text"
          v-model="v_inicial"
          :options="optionsNumeric"
        >
        </vue-autonumeric>
      </div>
      <div class="form-group">
        <label class="form-label">
          Valor a financiar
        </label>
        <vue-autonumeric
          :class="['form-control', v_vehiculo_financiar ? 'feedback_input' : '']"
          type="text"
          :value="calcularMonto(v_vehiculo, v_inicial)"
          disabled
          :options="optionsNumeric"
        ></vue-autonumeric>
        <div class="feedback">
          <span v-if="v_vehiculo_financiar">El valor debe ser mínimo $20.000.000</span>
        </div>
      </div>
      <div class="form-group">
        <label class="form-label">
          Plazo en meses
          <span class="text-danger">*</span>
        </label>
        <div class="select">
          <select
            :class="['form-control', plazo_req ? 'feedback_input' : '']"
            v-model="plazo"
          >
            <option value="12">12 meses</option>
            <option value="24">24 meses</option>
            <option value="36">36 meses</option>
            <option value="48">48 meses</option>
            <option value="60">60 meses</option>
            <option value="72">72 meses</option>
            <option value="84">84 meses</option>
          </select>
        </div>
        <div class="feedback">
          <span v-if="plazo_req">Este campo es requerido</span>
        </div>
      </div>
      <div>
        <b-card no-body class="border-left-danger border-danger shadow mb-2">
          <b-card-text class="mb-0 p-2">
              <b-row>
                <b-col md="2" class="pr-0">
                  <i class="fa fa-car fa-3x"></i>
                </b-col>
                <b-col md="10">
                  <span>
                    Cuota Mensual
                  </span>
                  <h3 class="text-uppercase text-bold">
                    $ {{v_cuota < 0 ? 0 : v_cuota}}
                  </h3>
                </b-col>
              </b-row>
          </b-card-text>
        </b-card>
      </div>
      <div class="form-group">
        <button
          @click="nextStep"
          class="btn btn-block"
          :disabled="disabledBtn"
        >
          Continuar
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapFields } from "vuex-map-fields";
export default {
  data() {
    return {
      v_vehiculo_req: false,
      v_vehiculo_val: false,
      v_vehiculo_financiar: false,
      plazo_req: false,
      disabledBtn: true,
      optionsNumeric: [
        'integerPos',
        {
          digitGroupSeparator: '.',
          decimalCharacter: ',',
          minimumValue: '0',
          maximumValue: '300000000',
          caretPositionOnFocus: "start",
          currencySymbol: "$"
        },
      ],
      resultado: null,
    }
  },
  computed: {
    ...mapFields("financiar", [
      "credito.v_vehiculo",
      "credito.v_inicial",
      "credito.vr_financiar",
      "credito.plazo",
      "credito.v_cuota",
      "asistente_step",
      "id_consignacion",
    ]),
  },
  watch: {
    v_vehiculo(newValue, oldValue) {
      if(newValue === 0) {
        this.v_vehiculo_req = true;
      }else {
        this.v_vehiculo_req = false;
        if(newValue >= 1 && newValue < 35000000) {
          this.v_vehiculo_val = true;
        }else {
          this.v_vehiculo_val = false;
        }
      }
    },
    vr_financiar(newValue, oldValue) {
      if(newValue < 20000000) {
        this.v_vehiculo_financiar = true;
      }else {
        this.v_vehiculo_financiar = false;
      }

      if(this.plazo != 0 && this.v_vehiculo_financiar != true && this.v_vehiculo_val != true) {
        this.simularCredito();
      }
    },
    plazo(newValue, oldValue) {
      if(newValue != 0) {
        this.simularCredito();
        this.disabledBtn = false;
      }
    },
  },
  methods: {
    simularCredito() {
      var monto = this.calcularMonto(this.v_vehiculo, this.v_inicial)
      var tasa = 0.013
    //   var tasa = tasa / 100.0
      var cuota =
        monto *
        ((tasa * Math.pow(1 + tasa, this.plazo)) /
          (Math.pow(1 + tasa, this.plazo) - 1))
      cuota = cuota.toFixed(0)
      var toInt = parseInt(cuota)
      this.v_cuota = toInt.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
      this.resultado = true
    },
    calcularMonto(v1, v2) {
      this.vr_financiar = v1 - v2;
      return this.vr_financiar;
    },
    nextStep() {
      if(this.v_vehiculo_financiar || this.v_vehiculo_val) {
        this.$swal.fire({
            icon: 'warning',
            title: 'No es posible procesar tu solicitud de crédito',
            text: '¡Debes tener en cuenta el monto mínimo del valor del vehículo y valor a financiar!',
            confirmButtonColor: '#858796'
        })
      }else {
        this.asistente_step = 'cliente';
        if(this.id_consignacion != '') {
          window.history.replaceState(null, null, '?step=2&ficha_tecnica=' + this.id_consignacion);
        }else {
          window.history.replaceState(null, null, '?step=2');
        }
      }
    }
  },
}
</script>

<style lang="scss">
  .feedback {
    color: red;
  }
  .feedback_input, .feedback_input:focus {
    border: 1px solid #ff0000;
  }
  .border-left-danger {
    border-left: 0.25rem solid #EA5455 !important;
  }
</style>
